import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotAward = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M32.562 36.385c2.014-2.938 1.484-7.56.954-13.088-.53-5.53-1.06-11.966-4.4-14.263-3.366-2.298-9.515-.455-14.497 2.484-4.983 2.964-8.773 6.998-8.614 10.71.159 3.713 4.24 7.052 7.448 10.284 3.207 3.232 5.565 6.303 9.01 7.211 3.473.882 8.058-.373 10.099-3.338Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="m13.683 23.15-2.017 15.183 8.334-5 8.333 5-2.017-15.2m5.35-9.8C31.665 19.778 26.441 25 19.998 25c-6.444 0-11.667-5.223-11.667-11.666 0-6.444 5.223-11.667 11.667-11.667 6.443 0 11.666 5.223 11.666 11.667Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotAward.displayName = "SpotAward";
